import { render, staticRenderFns } from "./SelectLanguageView.vue?vue&type=template&id=83b7252a&"
import script from "./SelectLanguageView.vue?vue&type=script&lang=js&"
export * from "./SelectLanguageView.vue?vue&type=script&lang=js&"
import style0 from "./SelectLanguageView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./SelectLanguageView.vue?vue&type=custom&index=0&blockType=i18nf"
if (typeof block0 === 'function') block0(component)

export default component.exports